import React from 'react';
import { Navigate } from 'react-router';

import acceptYourSeatsRoutes from '../components/CMS/Guest/AcceptYourSeat/routes';
import accountSettingsRoutes from '../components/CMS/Guest/AccountSettings/routes';
import cartRoutes from '../components/CMS/Guest/Cart/routes';
import checkoutRoutes from '../components/CMS/Guest/Checkout/routes';
import clinicianLocatorRoutes from '../components/CMS/Guest/ClinicianLocator/routes';
import dashboardRoutes from '../components/CMS/Guest/Dashboard/routes';
import designationRoutes from '../components/CMS/Guest/TrainingCertification/routes';
import previewPDFRoutes from '../components/CMS/Subscriber/PreviewPDF/routes';
import sellingGroupsRoutes from '../components/CMS/Guest/SellingGroups/routes';
import verifySeatRoutes from '../components/CMS/Guest/VerifySeat/routes';

// A route object has the same properties as a <Route>
// element. The `children` is just an array of child routes.
const guestRoutes = [
     dashboardRoutes,
     designationRoutes,
     cartRoutes,
     checkoutRoutes,
     sellingGroupsRoutes,
     acceptYourSeatsRoutes,
     verifySeatRoutes,
     clinicianLocatorRoutes,
     accountSettingsRoutes,
     previewPDFRoutes,
     {
          path: '*',
          element: <Navigate to="/" />,
     },
];

export default guestRoutes;
